import "babel-polyfill";
import "lodash";
import "jquery";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { OidcProvider } from "redux-oidc";
import { browserHistory, Router } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import configureStore from "./store/configureStore";
import routes from "./routes";
import * as dashboardActions from "./dashboard/dashboardActions";
import endpointConfig from "./endpointConfig";
import userManager from "./oidc/userManager";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { unregister } from "./registerServiceWorker";

/** bootstrap, css, fontawesome */
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/site.css";
import "font-awesome/css/font-awesome.css";

const initialState = {};

const store = configureStore(initialState);
const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <I18nextProvider i18n={i18n}>
        <Router history={history} children={routes} />
      </I18nextProvider>
    </OidcProvider>
  </Provider>,
  document.getElementById("root")
);

if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.js